import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'business-center-api.vendasta-local.com',
  'test': '',
  'demo': 'business-center-demo.apigateway.co',
  'prod': 'business-center-prod.apigateway.co',
  'production': 'business-center-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class Address {
  static fromProto(proto) {
    let m = new Address();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    return toReturn;
  }
}
class BusinessData {
  static fromProto(proto) {
    let m = new BusinessData();
    m = Object.assign(m, proto);
    if (proto.address) {
      m.address = Address.fromProto(proto.address);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.businessCategory !== 'undefined') {
      toReturn['businessCategory'] = this.businessCategory;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.websiteUrl !== 'undefined') {
      toReturn['websiteUrl'] = this.websiteUrl;
    }
    if (typeof this.facebookUrl !== 'undefined') {
      toReturn['facebookUrl'] = this.facebookUrl;
    }
    if (typeof this.twitterUrl !== 'undefined') {
      toReturn['twitterUrl'] = this.twitterUrl;
    }
    return toReturn;
  }
}
class Connection {
  static fromProto(proto) {
    let m = new Connection();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GetConnectionsResponseConnectionsEntry {
  static fromProto(proto) {
    let m = new GetConnectionsResponseConnectionsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = RepeatedConnection.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    return toReturn;
  }
}
class CreateAndAssociateRequest {
  static fromProto(proto) {
    let m = new CreateAndAssociateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    if (typeof this.confirmPassword !== 'undefined') {
      toReturn['confirmPassword'] = this.confirmPassword;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.greetingName !== 'undefined') {
      toReturn['greetingName'] = this.greetingName;
    }
    if (typeof this.sendWelcomeEmail !== 'undefined') {
      toReturn['sendWelcomeEmail'] = this.sendWelcomeEmail;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.failOnExistingUser !== 'undefined') {
      toReturn['failOnExistingUser'] = this.failOnExistingUser;
    }
    if (typeof this.notificationsFlag !== 'undefined') {
      toReturn['notificationsFlag'] = this.notificationsFlag;
    }
    return toReturn;
  }
}
class CreateAndAssociateResponse {
  static fromProto(proto) {
    let m = new CreateAndAssociateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class DeleteFileRequest {
  static fromProto(proto) {
    let m = new DeleteFileRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileId !== 'undefined') {
      toReturn['fileId'] = this.fileId;
    }
    return toReturn;
  }
}
class GetConnectionsRequest {
  static fromProto(proto) {
    let m = new GetConnectionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetConnectionsResponse {
  static fromProto(proto) {
    let m = new GetConnectionsResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = Object.keys(proto.connections).reduce((obj, k) => {
        obj[k] = RepeatedConnection.fromProto(proto.connections[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    return toReturn;
  }
}
class GetCreatePasswordUrlRequest {
  static fromProto(proto) {
    let m = new GetCreatePasswordUrlRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetCreatePasswordUrlResponse {
  static fromProto(proto) {
    let m = new GetCreatePasswordUrlResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetTrackerRequest {
  static fromProto(proto) {
    let m = new GetTrackerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetTrackerResponse {
  static fromProto(proto) {
    let m = new GetTrackerResponse();
    m = Object.assign(m, proto);
    if (proto.trackers) {
      m.trackers = Trackers.fromProto(proto.trackers);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trackers !== 'undefined' && this.trackers !== null) {
      toReturn['trackers'] = 'toApiJson' in this.trackers ? this.trackers.toApiJson() : this.trackers;
    }
    return toReturn;
  }
}
class GetWelcomeEmailTemplateRequest {
  static fromProto(proto) {
    let m = new GetWelcomeEmailTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userName !== 'undefined') {
      toReturn['userName'] = this.userName;
    }
    if (typeof this.loginUrl !== 'undefined') {
      toReturn['loginUrl'] = this.loginUrl;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetWelcomeEmailTemplateResponse {
  static fromProto(proto) {
    let m = new GetWelcomeEmailTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateHtml !== 'undefined') {
      toReturn['templateHtml'] = this.templateHtml;
    }
    return toReturn;
  }
}
class RegisterRequest {
  static fromProto(proto) {
    let m = new RegisterRequest();
    m = Object.assign(m, proto);
    if (proto.businessData) {
      m.businessData = BusinessData.fromProto(proto.businessData);
    }
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessData !== 'undefined' && this.businessData !== null) {
      toReturn['businessData'] = 'toApiJson' in this.businessData ? this.businessData.toApiJson() : this.businessData;
    }
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.recaptcha !== 'undefined') {
      toReturn['recaptcha'] = this.recaptcha;
    }
    return toReturn;
  }
}
class RegisterResponse {
  static fromProto(proto) {
    let m = new RegisterResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class RepeatedConnection {
  static fromProto(proto) {
    let m = new RepeatedConnection();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = proto.connection.map(Connection.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    return toReturn;
  }
}
class SendWelcomeEmailRequest {
  static fromProto(proto) {
    let m = new SendWelcomeEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.loginUrl !== 'undefined') {
      toReturn['loginUrl'] = this.loginUrl;
    }
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class SetTrackerRequest {
  static fromProto(proto) {
    let m = new SetTrackerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.tracker !== 'undefined') {
      toReturn['tracker'] = this.tracker;
    }
    return toReturn;
  }
}
class SetTrackerResponse {
  static fromProto(proto) {
    let m = new SetTrackerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class Trackers {
  static fromProto(proto) {
    let m = new Trackers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.welcomeVideo !== 'undefined') {
      toReturn['welcomeVideo'] = this.welcomeVideo;
    }
    if (typeof this.academy !== 'undefined') {
      toReturn['academy'] = this.academy;
    }
    return toReturn;
  }
}

// *********************************

// *********************************
let AccountApiService = /*#__PURE__*/(() => {
  class AccountApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    register(r) {
      const request = r.toApiJson ? r : new RegisterRequest(r);
      return this.http.post(this._host + "/business_center.v1.Account/Register", request.toApiJson(), this.apiOptions()).pipe(map(resp => RegisterResponse.fromProto(resp)));
    }
    deleteFile(r) {
      const request = r.toApiJson ? r : new DeleteFileRequest(r);
      return this.http.post(this._host + "/business_center.v1.Account/DeleteFile", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AccountApiService.ɵfac = function AccountApiService_Factory(t) {
    return new (t || AccountApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountApiService,
    factory: AccountApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccountService = /*#__PURE__*/(() => {
  class AccountService {
    constructor(http, hostService, accountApiService) {
      this.http = http;
      this.hostService = hostService;
      this.accountApiService = accountApiService;
    }
    register(businessData, contact, businessName, partnerId, marketId, email, recaptcha) {
      // prepare request data
      const requestData = {
        businessData,
        contact,
        businessName,
        partnerId,
        marketId,
        email,
        recaptcha
      };
      // http request call
      const request = new RegisterRequest(requestData);
      return this.accountApiService.register(request);
    }
    deleteFile(fileId) {
      const data = {
        fileId: fileId
      };
      const r = new DeleteFileRequest(data);
      return this.accountApiService.deleteFile(r);
    }
  }
  AccountService.ɵfac = function AccountService_Factory(t) {
    return new (t || AccountService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService), i0.ɵɵinject(AccountApiService));
  };
  AccountService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountService,
    factory: AccountService.ɵfac,
    providedIn: 'root'
  });
  return AccountService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let GetStartedApiService = /*#__PURE__*/(() => {
  class GetStartedApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTracker(r) {
      const request = r.toApiJson ? r : new GetTrackerRequest(r);
      return this.http.post(this._host + "/business_center.v1.GetStarted/GetTracker", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTrackerResponse.fromProto(resp)));
    }
    setTracker(r) {
      const request = r.toApiJson ? r : new SetTrackerRequest(r);
      return this.http.post(this._host + "/business_center.v1.GetStarted/SetTracker", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetTrackerResponse.fromProto(resp)));
    }
  }
  GetStartedApiService.ɵfac = function GetStartedApiService_Factory(t) {
    return new (t || GetStartedApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  GetStartedApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GetStartedApiService,
    factory: GetStartedApiService.ɵfac,
    providedIn: 'root'
  });
  return GetStartedApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GetStartedService = /*#__PURE__*/(() => {
  class GetStartedService {
    constructor(http, hostService, getStartedApiService) {
      this.http = http;
      this.hostService = hostService;
      this.getStartedApiService = getStartedApiService;
    }
    setTracker(partnerId, userId, tracker) {
      // prepare request data
      const requestData = {
        partnerId: partnerId,
        userId: userId,
        tracker: tracker
      };
      // http request call
      const request = new SetTrackerRequest(requestData);
      return this.getStartedApiService.setTracker(request);
    }
    getTracker(partnerId, userId) {
      // prepare request data
      const requestData = {
        partnerId: partnerId,
        userId: userId
      };
      // http request call
      const request = new GetTrackerRequest(requestData);
      return this.getStartedApiService.getTracker(request);
    }
  }
  GetStartedService.ɵfac = function GetStartedService_Factory(t) {
    return new (t || GetStartedService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService), i0.ɵɵinject(GetStartedApiService));
  };
  GetStartedService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GetStartedService,
    factory: GetStartedService.ɵfac,
    providedIn: 'root'
  });
  return GetStartedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ConnectionsApiService = /*#__PURE__*/(() => {
  class ConnectionsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getConnections(r) {
      const request = r.toApiJson ? r : new GetConnectionsRequest(r);
      return this.http.post(this._host + "/business_center.v1.Connections/GetConnections", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionsResponse.fromProto(resp)));
    }
  }
  ConnectionsApiService.ɵfac = function ConnectionsApiService_Factory(t) {
    return new (t || ConnectionsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConnectionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConnectionsApiService,
    factory: ConnectionsApiService.ɵfac,
    providedIn: 'root'
  });
  return ConnectionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let UserApiService = /*#__PURE__*/(() => {
  class UserApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCreatePasswordUrl(r) {
      const request = r.toApiJson ? r : new GetCreatePasswordUrlRequest(r);
      return this.http.post(this._host + "/business_center.v1.User/GetCreatePasswordUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCreatePasswordUrlResponse.fromProto(resp)));
    }
    sendWelcomeEmail(r) {
      const request = r.toApiJson ? r : new SendWelcomeEmailRequest(r);
      return this.http.post(this._host + "/business_center.v1.User/SendWelcomeEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getWelcomeEmailTemplate(r) {
      const request = r.toApiJson ? r : new GetWelcomeEmailTemplateRequest(r);
      return this.http.post(this._host + "/business_center.v1.User/GetWelcomeEmailTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWelcomeEmailTemplateResponse.fromProto(resp)));
    }
    createAndAssociate(r) {
      const request = r.toApiJson ? r : new CreateAndAssociateRequest(r);
      return this.http.post(this._host + "/business_center.v1.User/CreateAndAssociate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAndAssociateResponse.fromProto(resp)));
    }
  }
  UserApiService.ɵfac = function UserApiService_Factory(t) {
    return new (t || UserApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  UserApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserApiService,
    factory: UserApiService.ɵfac,
    providedIn: 'root'
  });
  return UserApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let UserService = /*#__PURE__*/(() => {
  class UserService {
    constructor(http, hostService, userApiService) {
      this.http = http;
      this.hostService = hostService;
      this.userApiService = userApiService;
    }
    sendWelcomeEmail(partnerId, userId, loginUrl, usePartnerDefaultDomain = false, marketId) {
      const requestData = {
        partnerId: partnerId,
        userId: userId,
        loginUrl: loginUrl,
        usePlatformDefaultDomain: usePartnerDefaultDomain || false,
        marketId: marketId
      };
      const request = new SendWelcomeEmailRequest(requestData);
      return this.userApiService.sendWelcomeEmail(request).pipe(map(res => res.status === 200));
    }
    getWelcomeEmailTemplate(partnerId, userName, loginUrl, marketId, welcomeMessage, languageCodeOverride) {
      const requestData = {
        partnerId: partnerId,
        userName: userName,
        loginUrl: loginUrl,
        marketId: marketId,
        welcomeMessage: welcomeMessage,
        languageCode: languageCodeOverride
      };
      const request = new GetWelcomeEmailTemplateRequest(requestData);
      return this.userApiService.getWelcomeEmailTemplate(request);
    }
  }
  UserService.ɵfac = function UserService_Factory(t) {
    return new (t || UserService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService), i0.ɵɵinject(UserApiService));
  };
  UserService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserService,
    factory: UserService.ɵfac,
    providedIn: 'root'
  });
  return UserService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccountService, Address, BusinessData, Contact, GetStartedService, SendWelcomeEmailRequest, Trackers, UserService };
